import { IStandardMultipleAutocomplete } from "../../_common/interface/autocomplete/iMultipleAutocomplete";
import { usersService } from "../../_services/users.service";
import { MultipleAutoComplete } from "./multiple.autocomplete";

interface IMultipleExtAutocomplete extends IStandardMultipleAutocomplete {
}

export const AgentsWithCaseDistanceMultipleAutoComplete = (params: IMultipleExtAutocomplete) => {

    return (
        <MultipleAutoComplete
            {...params}
            loadOnOpen
            itemsLoader={() => usersService.getAgentsWithCaseDistance(params.parentId!)}
            label={"Agents"} />
    );
}